module.exports = __webpack_public_path__ + "static/media/YF82_7.105c8305.jpg";